import { Geometry } from "./geometry";
import { Face } from "./face";
import { Vector3 } from "../math/vector";
export class Plane extends Geometry {
    constructor(width, height, color) {
        let vertices = [
            Vector3.fromValues(0, 0, 0),
            Vector3.fromValues(width, 0, 0),
            Vector3.fromValues(width, -height, 0),
            Vector3.fromValues(0, -height, 0),
        ];
        let faces = [new Face([0, 1, 2, 3], vertices, color)];
        super(vertices, faces);
    }
}
